import { apiGet, apiPut } from "../../../utils";

export function getAdminProfileAPI() {
  return apiGet(`/api/auth/profile`);
}

export function updateAdminProfileAPI(data) {
  return apiPut(`/auth/profile/update`, data);
}
